import {
  formEncode,
  getToken,
  handleResponse,
  nextFormDataApi,
  nextJsonApi,
} from '@/API/core';

const outcomeStatus = {
  fetchRowData: async () => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.get('/outcome-status', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },

  addOutcomeStatus: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.post('/outcome-status', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },

  editOutcomeStatus: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.put(
        '/outcome-status',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },

  deleteOutcomeStatus: async (uniqueId: number) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.delete(
        `/outcome-status?uniqueId=${uniqueId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default outcomeStatus;
